import { call, put, takeLatest, select } from "@redux-saga/core/effects";
import { mergeKycWithLoginProfile } from "helper/ckycPrefill";
import { PHCOnboardingApis } from "./PHCOnboardingApis";
import { PHCOnboardingParser } from "./PHCOnboardingParser";
import { PHCOnboardingConstants } from "./PHCOnboardingConstants";
import { PHCOnboardingActions } from "./PHCOnboardingAction";

function* getOnboardingDataSaga() {
  try {
    yield put({
      type: PHCOnboardingConstants.PHC_ONBOARDING_DATA_REQUEST,
    });

    const res = yield call(PHCOnboardingApis.getOnboardingData);
    const payload = PHCOnboardingParser.onboardingData(res);
    const loginProfile = yield select((state) => state.customer.loginProfile);
    const portfolioId = yield select((state) => state.PHC.PHCOnboarding.portfolioId);
    const kyc = mergeKycWithLoginProfile(payload, loginProfile);

    yield put({
      type: PHCOnboardingConstants.PHC_ONBOARDING_DATA_RESPONSE,
      payload,
    });
    yield put(
      PHCOnboardingActions.updatePHCOnboardingData({
        panNumber: kyc.panNumber,
        dateOfBirth: kyc.dateOfBirth,
        aadharNumber: kyc.aadharNumber,
        portfolioId: payload.portfolioId || portfolioId,
      }),
    );
    // Do not call getConsentId here — getOnboardingData is dispatched from many
    // places; consent follow-up is handled only where needed (e.g. preview-token flow).
  } catch (e) {
    yield put({
      type: PHCOnboardingConstants.PHC_ONBOARDING_DATA_RESPONSE,
      payload: {},
    });
  }
}

export function* registerPHCOnboardingSagas() {
  yield takeLatest(
    PHCOnboardingConstants.PHC_ONBOARDING_DATA_SAGA,
    getOnboardingDataSaga,
  );
}
